
export default {
  ADD_TESTIMONIAL (state, testimonial) {
    state.testimonials.unshift(testimonial)
  },
  SET_TESTIMONIAL (state, testimonials) {
    state.testimonials = testimonials
  },
  // SET_LABELS(state, labels) {
  //   state.eventLabels = labels
  // },
  UPDATE_TESTIMONIAL (state, testimonial) {
    const testimonialIndex = state.testimonials.findIndex((p) => p._id === testimonial._id)
    Object.assign(state.testimonials[testimonialIndex], testimonial)
  },
  REMOVE_TESTIMONIAL (state, testimonialId) {
    const testimonialIndex = state.testimonials.findIndex((p) => p.id === testimonialId)
    state.testimonials.splice(testimonialIndex, 1)
  }
}
